(() => {
  const init = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    root.querySelectorAll('[data-kd-open]').forEach(button => button.addEventListener('click', () => {
      const dialog = document.getElementById(button.dataset.kdOpen);
      if (dialog && !dialog.open) dialog.showModal();
    }));
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelectorAll('[data-kd-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close(); } });
    });
    const galleryMain = root.querySelector('[data-gallery-main]');
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const galleryCount = root.querySelector('[data-gallery-count]');
    let galleryIndex = 0;

    const showImage = (index) => {
      if (!thumbs.length || !galleryMain) return;
      galleryIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[galleryIndex];
      if (thumb.dataset.srcset) galleryMain.srcset = thumb.dataset.srcset;
      else galleryMain.removeAttribute('srcset');
      if (thumb.dataset.sizes) galleryMain.sizes = thumb.dataset.sizes;
      galleryMain.src = thumb.dataset.src;
      galleryMain.alt = thumb.dataset.alt || '';
      thumbs.forEach((item, itemIndex) => {
        const active = itemIndex === galleryIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', String(active));
      });
      if (galleryCount) galleryCount.textContent = `${galleryIndex + 1} / ${thumbs.length}`;
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showImage(galleryIndex - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(galleryIndex + 1));

    const colorMedia = JSON.parse(root.querySelector('[data-color-media-json]')?.textContent || '{}');
    const findColorSelect = (row) => row && [...row.querySelectorAll('select')].find((select) =>
      [...select.options].some((option) => Object.prototype.hasOwnProperty.call(colorMedia, option.value))
    );
    const moonHost = root.querySelector('.kdoucenuit__moon-host');
    const sticky = root.querySelector('[data-sticky-atc]');
    const stickyImage = sticky?.querySelector('img');
    const stickyPrice = sticky?.querySelector('.kdoucenuit__sticky-copy span');
    const stickySelectors = sticky?.querySelector('[data-sticky-selectors]');
    const stickyItem = sticky?.querySelector('[data-sticky-item]');
    const stickyColor = sticky?.querySelector('[data-sticky-color]');
    const stickySize = sticky?.querySelector('[data-sticky-size]');
    const activeRows = () => [...root.querySelectorAll('.moonbundle-option-active .moonbundle-variant-row')];
    const copyOptions = (target, source) => {
      if (!target || !source) return;
      const signature = JSON.stringify([...source.options].map(o => [o.value, o.textContent, o.disabled]));
      if (target.dataset.options !== signature) {
        target.replaceChildren(...[...source.options].map(o => o.cloneNode(true)));
        target.dataset.options = signature;
      }
      target.value = source.value;
      target.disabled = source.disabled;
    };
    const syncStickySelectors = () => {
      if (!stickySelectors) return;
      const rows = activeRows();
      stickySelectors.hidden = !rows.length;
      if (!rows.length) return;
      if (stickyItem.options.length !== rows.length) {
        const previous = Number(stickyItem.value) || 0;
        stickyItem.replaceChildren(...rows.map((_, i) => new Option(`Couette ${i + 1}`, String(i))));
        stickyItem.value = String(Math.min(previous, rows.length - 1));
      }
      sticky.querySelector('[data-sticky-item-label]').hidden = rows.length === 1;
      const row = rows[Number(stickyItem.value) || 0];
      const color = findColorSelect(row);
      const size = [...row.querySelectorAll('select')].find(select => select !== color);
      copyOptions(stickyColor, color);
      copyOptions(stickySize, size);
    };
    stickyItem?.addEventListener('change', syncStickySelectors);
    const applyStickySelection = (isColor) => {
      const row = activeRows()[Number(stickyItem.value) || 0];
      if (!row) return;
      const color = findColorSelect(row);
      const source = isColor ? color : [...row.querySelectorAll('select')].find(select => select !== color);
      const value = (isColor ? stickyColor : stickySize).value;
      if (!source || ![...source.options].some(o => o.value === value && !o.disabled)) return;
      source.value = value;
      source.dispatchEvent(new Event('change', { bubbles: true }));
      scheduleMoonVariantImages();
      window.setTimeout(scheduleMoonVariantImages, 80);
    };
    stickyColor?.addEventListener('change', () => applyStickySelection(true));
    stickySize?.addEventListener('change', () => applyStickySelection(false));
    let moonSyncFrame = 0;
    let lastGalleryColor = '';

    const normalizeImageUrl = (value) => {
      if (!value) return '';
      try {
        return new URL(value, window.location.origin).href;
      } catch (_error) {
        return value;
      }
    };

    const syncMoonVariantImages = () => {
      const moon = root.querySelector('moonbundle-component');
      if (!moon) return;
      if (root.dataset.kdMoonDefaultSet !== 'true') {
        const duoOffer = moon.querySelectorAll('.moonbundle-option-wrapper')[1]?.querySelector('.moonbundle-option');
        root.dataset.kdMoonDefaultSet = 'true';
        if (duoOffer && !duoOffer.classList.contains('moonbundle-option-active')) {
          duoOffer.click();
          window.setTimeout(scheduleMoonVariantImages, 80);
          return;
        }
      }
      moon.querySelectorAll('.moonbundle-variant-row').forEach((row) => {
        const target = row.querySelector('.moonbundle-variant-select-with-image');
        const colorSelect = findColorSelect(row);
        if (!target || !colorSelect) return;
        let image = target.querySelector('.kd-moon-variant-thumb');
        if (!image) {
          image = document.createElement('img');
          image.className = 'kd-moon-variant-thumb';
          image.alt = '';
          image.width = 52;
          image.height = 52;
          image.loading = 'lazy';
          image.decoding = 'async';
          image.fetchPriority = 'low';
          target.prepend(image);
        }
        const nextSrc = normalizeImageUrl(colorMedia[colorSelect.value] || colorMedia['Bleu côtier'] || '');
        if (nextSrc && image.src !== nextSrc) image.src = nextSrc;
        if (colorSelect.dataset.kdColorImageBound !== 'true') {
          colorSelect.dataset.kdColorImageBound = 'true';
          colorSelect.addEventListener('change', () => {
            const refreshRowImage = () => {
              const rowImage = row.querySelector('.kd-moon-variant-thumb');
              const rowSrc = normalizeImageUrl(colorMedia[colorSelect.value] || colorMedia['Bleu côtier'] || '');
              if (rowImage && rowSrc && rowImage.src !== rowSrc) rowImage.src = rowSrc;
              scheduleMoonVariantImages();
            };
            refreshRowImage();
            window.setTimeout(refreshRowImage, 80);
          }, true);
        }
      });

      const active = moon.querySelector('.moonbundle-option-active');
      const activeColor = findColorSelect(active?.querySelector('.moonbundle-variant-row'))?.value;
      const activePrice = active?.querySelector('.moonbundle-option-single-price')?.textContent?.trim();
      if (activeColor && activeColor !== lastGalleryColor) {
        lastGalleryColor = activeColor;
        const colorPath = new URL(normalizeImageUrl(colorMedia[activeColor])).pathname;
        const matchingThumb = thumbs.findIndex(thumb => new URL(normalizeImageUrl(thumb.dataset.src)).pathname === colorPath);
        if (matchingThumb >= 0) showImage(matchingThumb);
      }
      const stickySrc = normalizeImageUrl(activeColor ? colorMedia[activeColor] : '');
      if (stickyImage && stickySrc && stickyImage.src !== stickySrc) stickyImage.src = stickySrc;
      if (stickyPrice && activePrice) stickyPrice.textContent = activePrice;
      syncStickySelectors();
    };

    function scheduleMoonVariantImages() {
      if (moonSyncFrame) return;
      moonSyncFrame = window.requestAnimationFrame(() => {
        moonSyncFrame = 0;
        syncMoonVariantImages();
      });
    }

    root.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLSelectElement) || !event.target.closest('moonbundle-component')) return;
      scheduleMoonVariantImages();
      window.setTimeout(scheduleMoonVariantImages, 80);
    }, true);
    root.addEventListener('click', (event) => {
      if (event.target.closest('.moonbundle-option-wrapper')) window.setTimeout(scheduleMoonVariantImages, 80);
    });
    const moonObserver = new MutationObserver(scheduleMoonVariantImages);
    if (moonHost) moonObserver.observe(moonHost, { childList: true, subtree: true });
    scheduleMoonVariantImages();

    let stickyFrame = 0;
    const updateSticky = () => {
      stickyFrame = 0;
      if (!sticky) return;
      const hero = root.querySelector('.kdoucenuit__hero');
      const shouldShow = hero ? hero.getBoundingClientRect().bottom < window.innerHeight * 0.38 : window.scrollY > 700;
      sticky.hidden = !shouldShow;
    };
    const scheduleSticky = () => {
      if (stickyFrame) return;
      stickyFrame = window.requestAnimationFrame(updateSticky);
    };
    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky, { passive: true });
    scheduleSticky();
    sticky?.querySelector('[data-sticky-submit]')?.addEventListener('click', () => {
      const submit = root.querySelector('[id^="ProductSubmitButton-"]');
      if (submit && !submit.disabled) submit.click();
      else moonHost?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  const initAll = () => document.querySelectorAll('[data-kdoucenuit]').forEach(init);
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
